(function (Drupal, $) {
  Drupal.behaviors.expandable = {
    attach: function attach(context) {
      // .off needed to prevent multiple click handlers that seem to happen when you toggle open,
      // interact with the menu categories on the Den page, and then try to toggle close
      $('.expandable__header').off().click(function () {
        $(this).parent().toggleClass('open');
        if($(this).parent().hasClass('open')) {
          $('.expandable__header__button').attr('aria-expanded', true);
          // $('.expandable__content').slideToggle();
        } else {
          $('.expandable__header__button').attr('aria-expanded', false);
          // $('.expandable__content').slideToggle();
        }
      });
    }
  };
})(Drupal, jQuery);
